import { render } from "./WelcomeBonusPopup.vue?vue&type=template&id=d3331c7c&ts=true"
import script from "./WelcomeBonusPopup.vue?vue&type=script&lang=ts"
export * from "./WelcomeBonusPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__